import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const TagIcon = (props) => (
  <SvgIcon viewBox="0 0 13 13" {...props}>
    <path
      d="M6.72253 0.390667L0.722531 6.39067C0.201865 6.91133 0.201865 7.75533 0.722531 8.276L4.72253 12.276C5.2432 12.7967 6.0872 12.7967 6.60786 12.276L12.6079 6.276C12.8579 6.026 12.9985 5.68667 12.9985 5.33333V1.33333C12.9985 0.596667 12.4019 0 11.6652 0H7.6652C7.31186 0 6.97253 0.140667 6.72253 0.390667ZM10.6652 3.33333C10.1132 3.33333 9.6652 2.88533 9.6652 2.33333C9.6652 1.78133 10.1132 1.33333 10.6652 1.33333C11.2172 1.33333 11.6652 1.78133 11.6652 2.33333C11.6652 2.88533 11.2172 3.33333 10.6652 3.33333Z"
      fill={props.sx?.color || '#3266F5'}
    />
  </SvgIcon>
);

TagIcon.propTypes = {
  sx: PropTypes.object,
};

export default TagIcon;
